var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.$root.logged_in,
          expression: "!$root.logged_in"
        }
      ],
      staticClass: "chi-form chi-twofa",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit($event)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("chi-welcome"),
          _c(
            "div",
            { staticClass: "chi-form-section right" },
            [
              _c("chi-announcements"),
              _c("div", { staticClass: "chi-form-section twofa-form" }, [
                _c("h2", { staticClass: "with-cropped-hr centered" }, [
                  _vm._v("Log Into Your Account")
                ]),
                _c("div", { staticClass: "chi-form-group chi-twofa-message" }, [
                  _vm._v(
                    " We sent " +
                      _vm._s(
                        _vm.message_type === "email"
                          ? "an email"
                          : "a text mes­sage"
                      ) +
                      " with a six‐digit se­cu­ri­ty code to " +
                      _vm._s(_vm.destination) +
                      ". Please en­ter it here. "
                  )
                ]),
                _c("div", {
                  staticClass: "chi-twofa-errors",
                  attrs: {
                    id: "chi-twofa-notifications",
                    "data-conn-message":
                      "Failed to connect to server. Please try again later.",
                    "data-fail-message": "Invalid security code!",
                    "data-code-message": "Security code cannot be blank!"
                  }
                }),
                _c(
                  "div",
                  {
                    staticClass: "chi-form-group chi-twofa-code",
                    class: { "has-chi-twofa-error": _vm.error.code }
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "chi-twofa-label",
                        attrs: { for: "code" }
                      },
                      [_vm._v("Security Code")]
                    ),
                    _c("br"),
                    _vm.code_visible
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.lazy",
                              value: _vm.model.code,
                              expression: "model.code",
                              modifiers: { lazy: true }
                            }
                          ],
                          ref: "code",
                          staticClass: "k-textbox md",
                          class: { "k-space-right": _vm.error.code },
                          attrs: {
                            id: "code",
                            tabindex: "1",
                            type: "text",
                            name: _vm.random
                          },
                          domProps: { value: _vm.model.code },
                          on: {
                            keypress: _vm.onkeypress,
                            change: function($event) {
                              return _vm.$set(
                                _vm.model,
                                "code",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _vm._e(),
                    _vm.error.code
                      ? _c("i", {
                          staticClass:
                            "fal fa-fw fa-exclamation-circle chi-twofa-error-icon",
                          attrs: {
                            title: _vm.error.code
                              ? "Invalid or blank security code"
                              : ""
                          }
                        })
                      : _vm._e(),
                    _c("br")
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.delay_reached,
                        expression: "delay_reached"
                      }
                    ],
                    staticClass: "chi-form-group chi-twofa-links"
                  },
                  [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.error.code || _vm.delay_reached,
                            expression: "error.code || delay_reached"
                          }
                        ],
                        staticClass: "chi-link",
                        attrs: { id: "resend_code", href: "#", tabindex: "2" },
                        on: { click: _vm.resend }
                      },
                      [
                        _vm._v(
                          "Resend the security code to " +
                            _vm._s(_vm.destination)
                        )
                      ]
                    ),
                    _c("br"),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.has_alternate &&
                              (_vm.error.code || _vm.delay_reached),
                            expression:
                              "has_alternate && (error.code || delay_reached)"
                          }
                        ],
                        staticClass: "chi-link",
                        attrs: {
                          id: "switch_method",
                          href: "#",
                          tabindex: "3"
                        },
                        on: { click: _vm.resend }
                      },
                      [
                        _vm._v(
                          "Send the security code by " +
                            _vm._s(
                              _vm.message_type === "email"
                                ? "text message"
                                : "email"
                            ) +
                            " instead"
                        )
                      ]
                    )
                  ]
                ),
                _c("div", { staticClass: "chi-form-group chi-twofa-trusted" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.lazy",
                        value: _vm.model.trusted,
                        expression: "model.trusted",
                        modifiers: { lazy: true }
                      }
                    ],
                    ref: "twofa-trusted",
                    staticClass: "k-checkbox",
                    attrs: {
                      id: "twofa-trusted",
                      tabindex: "4",
                      type: "checkbox"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.model.trusted)
                        ? _vm._i(_vm.model.trusted, null) > -1
                        : _vm.model.trusted
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.model.trusted,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(_vm.model, "trusted", $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.model,
                                "trusted",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.model, "trusted", $$c)
                        }
                      }
                    }
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "k-checkbox-label",
                      attrs: { for: "twofa-trusted" }
                    },
                    [
                      _vm._v(
                        "This is a trus­ted de­vice. Don't ask for a code eve­ry time."
                      )
                    ]
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "chi-button-group chi-form-group" },
                  [
                    _c(
                      "kendo-button",
                      {
                        staticClass: "chi-button-primary",
                        attrs: {
                          id: "login",
                          "sprite-css-class": "chi-icon-log-in",
                          tabindex: "5",
                          type: "submit"
                        }
                      },
                      [_vm._v("Log In")]
                    ),
                    _c(
                      "kendo-button",
                      {
                        attrs: {
                          id: "clear",
                          "sprite-css-class": "chi-icon-backspace",
                          tabindex: "6",
                          type: "reset"
                        },
                        on: {
                          click: function($event) {
                            return _vm.clear()
                          }
                        }
                      },
                      [_vm._v("Clear")]
                    ),
                    _c(
                      "kendo-button",
                      {
                        staticClass: "chi-button-danger",
                        attrs: {
                          id: "cancel",
                          "sprite-css-class": "chi-icon-cancel",
                          tabindex: "7"
                        },
                        on: {
                          click: function($event) {
                            return _vm.cancel()
                          }
                        }
                      },
                      [_vm._v("Cancel")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }